import React from "react";
import { TimelineStep } from "./TimelineStep";

export interface TimelineEvent {
  status: string;
  role: string;
  color: string;
  completed: boolean;
  date?: string | Date | null;
  user?: string | null;
  userFullName?: string | null;
}

export interface TimelineProps {
  events: TimelineEvent[];
  currentStatus?: string;
  size?: "xs" | "sm" | "md" | "lg";
  showLabels?: boolean;
  className?: string;
  onStepClick?: (event: TimelineEvent, index: number) => void;
}

export const Timeline: React.FC<TimelineProps> = ({
  events,
  currentStatus,
  size = "md",
  showLabels = true,
  className = "",
  onStepClick,
}) => {
  const currentIndex = events.findIndex((e) => e.status === currentStatus);

  return (
    <div className={`w-full overflow-x-auto ${className}`}>
      <ol className="flex items-center min-w-max">
        {events.map((event, index) => {
          const isActive = event.status === currentStatus;
          const isCompleted = currentIndex > index || event.completed;
          const isPending = !isCompleted && !isActive;

          return (
            <TimelineStep
              key={index}
              status={event.status}
              role={event.role}
              color={event.color}
              completed={isCompleted}
              isActive={isActive}
              isPending={isPending}
              isLast={index === events.length - 1}
              size={size}
              showLabel={showLabels}
              onClick={
                onStepClick ? () => onStepClick(event, index) : undefined
              }
            />
          );
        })}
      </ol>
    </div>
  );
};